export const validateNotEmpty = (value: string): string | null => {
  if (!value) {
    return "Empty field is not allowed";
  }
  return null;
};
